import { createSelector } from "reselect";

/**
 * selector to determine if patient overview allergies is enabled
 */
export const patientOverviewAllergiesEnabledSelector = createSelector(
  () => false
);
